import cn from 'classnames';
import { RadioButton } from 'primereact/radiobutton';
import { ReactNode } from 'react';

import styles from './UpsellOptionCard.module.scss';

interface UpsellOptionCardProps {
  inputId: string;
  groupName: string;
  value: string;
  label?: string;
  isSelected: boolean;
  isDisabled?: boolean;
  selectCallback: (value: string) => void;
  icon?: ReactNode;
  amountLabel?: string;
  helperText?: string;
  tooltip?: ReactNode;
  dataTestId: string;
}

export function UpsellOptionCard({
  inputId,
  groupName,
  value,
  label,
  isSelected,
  isDisabled = false,
  selectCallback,
  icon,
  amountLabel,
  helperText,
  tooltip,
  dataTestId,
}: UpsellOptionCardProps) {
  return (
    <div
      className={cn(styles.wrapper, { [styles.active]: isSelected, [styles.disabledWrapper]: isDisabled })}
      data-testid={`${dataTestId}-card`}
    >
      <label
        htmlFor={inputId}
        className={cn(styles.labelContainer, { [styles.disabledLabel]: isDisabled })}
        data-testid={dataTestId}
      >
        <div className={styles.box}>
          <RadioButton
            inputId={inputId}
            name={groupName}
            value={value}
            checked={isSelected}
            disabled={isDisabled}
            onChange={() => selectCallback(value)}
          />
          {icon && <span className={styles.icon}>{icon}</span>}
          <div className={styles.texts}>
            {(label || tooltip) && (
              <span className={styles.label}>
                {label}
                {tooltip}
              </span>
            )}
            {amountLabel && <p className={styles.amount}>{amountLabel}</p>}
            {helperText && <span className={styles.helperText}>{helperText}</span>}
          </div>
        </div>
      </label>
    </div>
  );
}
